import React from 'react';
import { 
  Box,
  Typography,
  Grid,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  alpha,
  useTheme,
  Stack
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { motion } from 'framer-motion';

const Learnyou = ({ courseKeyPoints = [] }) => {
  const theme = useTheme();

  if (!courseKeyPoints || courseKeyPoints.length === 0) {
    return null;
  }

  return (
    <Box sx={{ my: 4 }}>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 4 }}>
        <Box sx={{ width: 4, height: 28, bgcolor: '#D4AF37', borderRadius: 2 }} />
        <Typography variant="h5" fontWeight={900} sx={{ letterSpacing: "-0.5px", color: "text.primary" }}>
          What You'll Learn
        </Typography>
      </Stack>

      <Grid container spacing={2}>
        {courseKeyPoints.map((point, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <motion.div
              whileHover={{ x: 5 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <Paper 
                elevation={0}
                sx={{ 
                  p: 2.5, 
                  borderRadius: "20px",
                  bgcolor: theme.palette.mode === 'dark' ? alpha('#D4AF37', 0.05) : '#FFFFFF',
                  border: '1px solid',
                  borderColor: theme.palette.mode === 'dark' ? alpha('#D4AF37', 0.1) : '#F1F5F9',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 2,
                  height: '100%',
                  boxShadow: theme.palette.mode === 'dark' ? 'none' : '0 4px 12px rgba(0,0,0,0.03)',
                }}
              >
                <CheckCircle sx={{ color: '#D4AF37', mt: 0.5, fontSize: 22 }} />
                <Typography 
                  variant="body1" 
                  fontWeight={600} 
                  sx={{ 
                    color: 'text.secondary',
                    lineHeight: 1.5
                  }}
                >
                  {point}
                </Typography>
              </Paper>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Learnyou;
